module.exports = __webpack_public_path__ + "img/mircopolyester_xl.490afa7.webp";